import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { resolveMinMax } from 'Utils'
import { pushPriceFilters, setPriceFilters } from 'Actions'

class FilterReduxHandler extends Component {
  componentDidMount() {
    this.props.pushPriceFilters(resolveMinMax(this.props.data))
  }

  componentDidUpdate(prevProps) {
    if (prevProps.url !== this.props.url) {
      this.props.setPriceFilters(false)
      this.props.pushPriceFilters(resolveMinMax(this.props.data))
    }
    if (prevProps.queryString !== this.props.queryString) {
      this.props.pushPriceFilters(resolveMinMax(this.props.data))
    }
  }

  render() {
    return null
  }
}

const mapDispatchToProps = dispatch => ({
  pushPriceFilters: bindActionCreators(pushPriceFilters, dispatch),
  setPriceFilters: bindActionCreators(setPriceFilters, dispatch)
})

export default connect(null, mapDispatchToProps)(FilterReduxHandler)
